import { FunctionComponent, useState } from 'react'
import Desktop from '@/modules/desktopMobile/desktop.tsx'
import Mobile from '@/modules/desktopMobile/mobile.tsx'
import { Daycare } from '@/types/Daycare.ts'
import HeaderPlanningDesktop from './headerPlanningDesktop/headerPlanningDesktop.tsx'
import HeaderPlanningMobile from './headerPlanningMobile/headerPlanningMobile.tsx'
import { Parent } from '@/types/Parent.ts'
import { PlanningRights, PlanningTabsState } from '@/hooks/usePlanningRights.ts'
import { SelectOptionsDeprecated } from '@/types/Select.ts'
import { PlanningKPIData } from '../hooks/usePlanningKPI.ts'
import RequestSlotDialog from '../Dialog/requestSlot/requestSlot/requestSlotDialog.tsx'
import { getChildsRequestSlot } from './headerHelper.ts'
import ReleaseScheduledOccasionalSlot from '../Dialog/releaseScheduledOccasionalSlot/releaseScheduledOccasionalSlot.tsx'

interface PlanningHeaderProps {
    currentDaycare: Daycare
    planningRights: PlanningRights
    planningTabs: PlanningTabsState
    currentView: string
    setCurrentView: (view: string) => void
    parent?: Parent
    refetchData: (isGlobalPlanning?: boolean) => void
    handleAddSlot: () => void
    selectFilters: string[]
    setSelectFilters: (filters: string[]) => void
    filterEvents: (filters: string[]) => void
    selectFiltersOptions: SelectOptionsDeprecated
    exportCalendar: () => void
    requestNumber: number
    handeSetFullScreen: () => void
    kpi: PlanningKPIData
    isFullScreen: boolean
}

const PlanningHeader: FunctionComponent<PlanningHeaderProps> = ({
    currentDaycare,
    planningRights,
    planningTabs,
    currentView,
    setCurrentView,
    parent,
    refetchData,
    handleAddSlot,
    setSelectFilters,
    selectFilters,
    filterEvents,
    selectFiltersOptions,
    exportCalendar,
    requestNumber,
    handeSetFullScreen,
    kpi,
    isFullScreen
}: PlanningHeaderProps) => {
    const [isRequestSlotDialogOpen, setRequestSlotDialogOpen] = useState<boolean>(false)
    const [isScheduledSlotsDialogOpen, setScheduledSlotsDialogOpen] = useState<boolean>(false)

    return (
        <>
            <Desktop>
                <HeaderPlanningDesktop
                    currentDaycare={currentDaycare}
                    planningRights={planningRights}
                    planningTabs={planningTabs}
                    parent={parent}
                    requestNumber={requestNumber}
                    currentView={currentView}
                    setCurrentView={setCurrentView}
                    refetchData={refetchData}
                    handleAddSlot={handleAddSlot}
                    setSelectFilters={setSelectFilters}
                    filterEvents={filterEvents}
                    selectFilters={selectFilters}
                    selectFiltersOptions={selectFiltersOptions}
                    exportCalendar={exportCalendar}
                    haveScheduledSlots={kpi.scheduledHours > 0}
                    handeSetFullScreen={handeSetFullScreen}
                    isFullScreen={isFullScreen}
                    setRequestSlotDialogOpen={setRequestSlotDialogOpen}
                    setScheduledSlotsDialogOpen={setScheduledSlotsDialogOpen}
                />
            </Desktop>
            <Mobile>
                <HeaderPlanningMobile
                    currentDaycare={currentDaycare}
                    parent={parent}
                    selectFiltersOptions={selectFiltersOptions}
                    currentView={currentView}
                    setCurrentView={setCurrentView}
                    refetchData={refetchData}
                    haveScheduledSlots={kpi.scheduledHours >= 1}
                    filterEvents={filterEvents}
                    setSelectFilters={setSelectFilters}
                    selectFilters={selectFilters}
                    kpi={kpi}
                    handleAddSlot={handleAddSlot}
                    planningRights={planningRights}
                    planningTabs={planningTabs}
                    requestNumber={requestNumber}
                    setScheduledSlotsDialogOpen={setScheduledSlotsDialogOpen}
                    setRequestSlotDialogOpen={setRequestSlotDialogOpen}
                />
            </Mobile>
            {isRequestSlotDialogOpen && (
                <RequestSlotDialog
                    open={isRequestSlotDialogOpen}
                    handleClose={() => setRequestSlotDialogOpen(false)}
                    childs={getChildsRequestSlot(currentDaycare.id, parent)}
                    currentDaycare={currentDaycare}
                    refetchData={() => refetchData(planningTabs.isGlobalTab)}
                />
            )}
            {isScheduledSlotsDialogOpen && (
                <ReleaseScheduledOccasionalSlot
                    open={isScheduledSlotsDialogOpen}
                    handleClose={() => setScheduledSlotsDialogOpen(false)}
                    daycare={currentDaycare}
                    refetchData={() => refetchData(planningTabs.isGlobalTab)}
                />
            )}
        </>
    )
}

export default PlanningHeader
